"use client";

import React, { useState, useEffect, useRef } from "react";
import { Button, CircularProgress, Box, Typography } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// import HeaderSection from "./components/HeaderSection";
// import BuyerSection from "./components/BuyerSection";
// import DetailsSection from "./components/DetailsSection";
// import ItemsTable from "./components/ItemsTable";
// import SummarySection from "./components/SummarySection";
// import FooterSection from "./components/FooterSection";

// import { Invoice } from "@/entities/Invoice";
import "./PhoneInvoice.scss";
import PhoneInvoiceHeader from "./PhoneInvoiceHeader";
import PhoneAccountDetails from "./PhooneAccountDetails";
import PhoneInvoiceDetails from "./PhoneInvoiceDetails";
import PhoneGridItems from "./PhoneGridItems";
import TotalsData from "./TotalsData";
import InvoiceFooter from "./InvoiceFooter";
export default function PhoneInvoicePage({
  companiedDetails,
  invoiceTranslate,
  transactiondetails,
  link,
  fiscalYear,
  actionType,
  invoiceNr,
  articleDetails,
  totalAmount0,
  totalAmount8,
  vat8,
  totalAmount18,
  vat18,
  totalAmount,
  amountPercent,
  banksdetails,
  onPrint,
}) {
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [Invoice, setInvoicee] = useState([]);
  const printRef = useRef(null);

  useEffect(() => {
    const loadInvoice = async () => {
      try {
        const invoices = await Invoice.list("createdAt:desc", 1);
        if (invoices.length > 0) {
          setInvoice(invoices[0]);
        }
      } catch (error) {
        console.error("Failed to load invoice:", error);
      } finally {
        setLoading(false);
      }
    };
    loadInvoice();
  }, []);

  const handleExport = async (format) => {
    const element = printRef.current;
    if (!element) return;

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    if (format === "png") {
      const dataUrl = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = `invoice-${
        invoice?.invoiceDetails?.serialNumber || "export"
      }.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: [canvas.width, canvas.height],
      });
      pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
      pdf.save(
        `invoice-${invoice?.invoiceDetails?.serialNumber || "export"}.pdf`
      );
    }
  };

  if (loading) {
    return (
      <Box className="invoice-loader">
        <CircularProgress />
      </Box>
    );
  }

  // if (!invoice) {
  //   return (
  //     <Box className="invoice-empty">
  //       <Typography variant="body1" color="text.secondary">
  //         No invoice data available.
  //       </Typography>
  //     </Box>
  //   );
  // }

  return (
    <Box className="invoice-page">
      <Box className="invoice-container">
        {/* Butonat */}
        <Box className="invoice-actions">
          {/* <PrintContent
            details={companiedDetails}
            companyDetails={invoiceTranslate}
            articleDetails={transactiondetails}
            bankaccounts={banksdetails}
            sasia="QtyOutput"
            actiontype="true"
            link={link}
            hasElectronicSeal={hasElectronicSeal}
          /> */}

          {/* <Button
            onClick={() => handleExport("png")}
            variant="outlined"
            size="small"
            startIcon={<ImageIcon fontSize="small" />}
          >
            PNG
          </Button> */}
          <Button
            variant="outlined"
            size="small"
            startIcon={<PictureAsPdfIcon fontSize="small" />}
            onClick={() => onPrint && onPrint()} // 🔗 lidhet direkt me prindin
          >
            Print
          </Button>
          {/* <Button
            onClick={onPrint}
            variant="outlined"
            size="small"
            startIcon={<PictureAsPdfIcon fontSize="small" />}
          >
            Print
          </Button> */}
        </Box>

        {/* Përmbajtja e faturës */}
        <Box ref={printRef} className="invoice-card">
          <PhoneInvoiceHeader
            companiedDetails={companiedDetails}
            invoiceTranslate={invoiceTranslate}
          />
          <PhoneAccountDetails
            transactiondetails={transactiondetails}
            invoiceTranslate={invoiceTranslate}
          />

          <PhoneInvoiceDetails
            transactiondetails={transactiondetails}
            invoiceTranslate={invoiceTranslate}
            link={link}
            fiscalYear={fiscalYear}
            actionType={actionType}
            invoiceNr={invoiceNr}
          />

          <PhoneGridItems
            invoiceTranslate={invoiceTranslate}
            companiedDetails={companiedDetails}
            articleDetails={articleDetails}
            transactiondetails={transactiondetails}
          />

          <TotalsData
            invoiceTranslate={invoiceTranslate}
            companiedDetails={companiedDetails}
            transactiondetails={transactiondetails}
            totalAmount0={totalAmount0}
            totalAmount8={totalAmount8}
            vat8={vat8}
            totalAmount18={totalAmount18}
            vat18={vat18}
            totalAmount={totalAmount}
            amountPercent={amountPercent}
          />

          <InvoiceFooter
            transactiondetails={transactiondetails}
            invoiceTranslate={invoiceTranslate}
            companiedDetails={companiedDetails}
            banksdetails={banksdetails}
          />
        </Box>
      </Box>
    </Box>
  );
}
